import { useEffect, useState } from 'react';
import FormLabel from '@mui/material/FormLabel';
import Slider, { SliderProps } from '@mui/material/Slider';
import { useAtom } from 'jotai';
import * as state from '@/state';

type Props = {
  title: string;
} & SliderProps;

const valuetext = (value: number) => {
  return `${value}`;
};

export const RgbBlendLevelSlider = ({ title, ...props }: Props) => {
  const [value, setValue] = useAtom<number>(state.rgbBlendLevel);
  const [unfinishedValue, setUnfinishedValue] = useState(value);

  useEffect(() => {
    const debounce = setTimeout(() => {
      setValue(unfinishedValue);
    }, 500);

    return () => clearTimeout(debounce);
  }, [setValue, unfinishedValue]);

  const handleValueChanged = (event: Event, value_: number | number[]) => {
    setUnfinishedValue(value_ as number);
  };

  return (
    <>
      <FormLabel>{title}</FormLabel>
      <Slider
        {...props}
        aria-label="RgbBlendLevel"
        min={1}
        max={255}
        step={1}
        getAriaValueText={valuetext}
        valueLabelDisplay="auto"
        value={value}
        onChange={handleValueChanged}
      />
    </>
  );
};
